import { FabNavItem } from '@fabric/components/common';

export const vehicleNavItems: FabNavItem[] = [
  {
    name: 'Inicio',
    route: '/home',
    iconName: 'home'
  },
  {
    name: 'Crear Vehicle Remito',
    route: '/create-vehicle-remito',
    iconName: 'create'
  },
  {
    name: 'Todos los Remitos',
    route: '/view-vehicle-remitos',
    iconName: 'search'
  },
  {
    name: 'Liberar vta directa',
    route: '/liberar-vta-directa',
    iconName: 'task_alt'
  },
  {
    name: 'Descarga de Archivos',
    route: '/vehicle-printed-remitos',
    iconName: 'task_alt'
  },
  {
    name: 'OTDS Errores',
    route: '/otds-error-processing',
    iconName: 'autorenew'
  },
  {
    name: 'Mantenimiento',
    iconName: 'view_list',
    subItems: [
      {
        name: 'Destinatario',
        route: '/destinatario-maintenance',
        iconName: 'move_down'
      },
      {
        name: 'Impresoras',
        route: '/impresoras-maintenance',
        iconName: 'group'
      },
      {
        name: 'Transporte',
        route: '/transporte-maintenance',
        iconName: 'move_down'
      },
      {
        name: 'Usuario',
        route: '/user-maintenance',
        iconName: 'group'
      },
      {
        name: 'Transp. Origen/Destino',
        route: '/destino-transportista-maintenance',
        iconName: 'move_down'
      },
      {
        name: 'Cong. Bloqueo Remitos',
        route: '/tpre-maintenance',
        iconName: 'move_down'
      },
      {
        name: 'Scheduled Tasks',
        route: '/scheduled-task-status',
        iconName: 'event'
      },
    ]
  }
];
